const CONSTANTS = {
  CURRENCY_SYMBOL: "$",
  CURRENCY: "USD",
  TRY_NOW_BUTTON_TEXT: "Start Free Trial",
  CART_URL: `https://${process.env.GATSBY_SHOPIFY_SHOP_NAME}.myshopify.com/cart`,
  SHOP_URL: `https://${process.env.GATSBY_SHOPIFY_SHOP_NAME}.myshopify.com`,
}

export default CONSTANTS
